var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramInternational64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./International64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramInternational",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "World-Outline",
    fill: "#FFFFFF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9448,6.0946 C39.9448,9.1676 38.6288,12.2016 35.8588,13.7046 C33.4758,14.9986 30.1328,14.0156 28.5888,16.6566 C27.1298,19.1526 28.7188,21.9626 31.3358,22.6376 C32.6158,22.9686 34.0848,22.9026 34.0968,24.7116 C34.1118,26.7766 30.6428,29.0846 29.4798,30.2476 C28.1928,31.5356 28.0698,31.5076 28.0698,33.3106 C28.0698,34.8836 28.3598,36.7596 27.4318,38.1336 C25.9978,40.2586 22.5118,40.3626 20.9008,38.4086 C19.0288,36.1396 20.2258,31.6476 20.0338,28.9346 C19.8568,26.4246 18.4968,25.0626 16.0168,24.7116 C13.0398,24.2906 10.4738,23.3106 8.9508,20.5066 C5.9248,14.9336 10.5438,8.0376 16.8388,8.6816 C19.0458,8.9076 20.7188,10.0486 22.2648,11.5586 C23.8308,13.0906 25.9158,15.4016 28.1408,13.1756 C29.2988,12.0176 29.3018,10.0736 28.1408,8.9126 C26.9828,7.7546 25.3218,8.2656 23.9838,7.4826 C21.4348,5.9916 21.3458,2.1126 23.9338,0.6176 C25.8818,-0.1814 28.5178,0.3146 30.4578,0.8766 C33.9448,1.8856 37.2548,3.6476 39.9448,6.0946 Z",
    id: "World",
    fill: "#FFCC00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramInternational64);
export default __webpack_public_path__ + "static/media/pictogramInternational64.e288ec174676b4506374d375e10444a9.svg";
export { ForwardRef as ReactComponent };